import React from 'react';
import { useAppSettings } from '../context/AppSettingsContext';
import { buildImageUrl } from '../utils/imageUrl';

const DynamicLogo = ({
  size = 'md',
  showText = true,
  textColor = 'inherit',
  className = '',
}) => {
  const { settings, imageBaseUrl } = useAppSettings();  // ✅ API se

  const storeName = settings?.general?.storeName || 'Hayat Herbal';
  const logo = settings?.general?.storeLogo;

  const sizeMap = {
    sm: { img: 28, text: 14, gap: 6 },
    md: { img: 36, text: 18, gap: 8 },
    lg: { img: 48, text: 22, gap: 10 },
    xl: { img: 64, text: 28, gap: 12 },
  };

  const s = sizeMap[size] || sizeMap.md;

  return (
    <div
      className={`dynamic-logo ${className}`}
      style={{ display: 'flex', alignItems: 'center', gap: s.gap }}
    >
      {logo ? (
        <img
          src={buildImageUrl(logo, imageBaseUrl)}  // ✅ API se
          alt={storeName}
          style={{
            width: s.img,
            height: s.img,
            objectFit: 'contain',
            borderRadius: 8,
            background: '#fff',
            padding: 2,
            flexShrink: 0,
          }}
        />
      ) : (
        <span style={{ fontSize: s.img - 8, flexShrink: 0 }}>🌿</span>
      )}

      {showText && (
        <span
          style={{
            fontSize: s.text,
            fontWeight: 700,
            color: textColor,
            whiteSpace: 'nowrap',
          }}
        >
          {storeName}
        </span>
      )}
    </div>
  );
};

export default DynamicLogo;